import { useSelector } from 'react-redux';
import { List, ListItem } from 'palette/List';
import { FILTER_TYPES } from '@common/Filters/constants/filterTypes';
import { filterSelectors } from '@common/Filters/selectors';
import { BrandsGroupFilter } from '../containers/BrandsGroupDesktop';
import { BrandFilterItem } from './BrandFilterItem';
import './BrandFilterItems.scss';

const getFirstLetter = brand => brand.name.charAt(0).toUpperCase();

const removeDuplicateLetters = (letters, letter) => {
    if (letters.indexOf(letter) === -1) {
        letters.push(letter);
    }

    return letters;
};

export function BrandFilterItems({
    brands, brandGroupsData, activeBrandIds
}) {
    const activeFilters = useSelector(filterSelectors.activeFilters);

    const brandsPerLetter = (letter) => {
        const letterArray = brands.filter(brand => getFirstLetter(brand) === letter);
        letterArray.key = letter;
        return letterArray;
    };

    const brandsByLetter = brands
        .filter(brand => brand.count > 0)
        .map(getFirstLetter)
        .reduce(removeDuplicateLetters, [])
        .map(letter => brandsPerLetter(letter));

    const isSelected = brandValue => activeFilters.some(
        activeFilter => activeFilter.filterType === FILTER_TYPES.brand && activeFilter.value === brandValue
    );

    return (
        <div className="brand-filter-items">
            <BrandsGroupFilter
                activeBrandIds={activeBrandIds}
                brandGroupsData={brandGroupsData}
                brands={brands}
            />
            {
                brandsByLetter.map(brandItems => (
                    <List key={brandItems.key}>
                        <ListItem
                            key={brandItems.key}
                            label={brandItems.key}
                            labelType="large-title"
                        />
                        {
                            brandItems.map(brand => (
                                <BrandFilterItem
                                    key={brand.name}
                                    brand={brand}
                                    brands={brandItems}
                                    filterType="brand"
                                    isSelected={isSelected(brand.value)}
                                />
                            ))
                        }
                    </List>
                ))
            }
        </div>
    );
}
